import service from '@/utils/request'
import { RoutePlan } from "@/routing/services/route-plan"
import { ServerRoutePlan } from '@/server-routing/services/route-plan'

// 规划路线 fleet v2
export function calculateroute(params, cancelToken) {
  return service({
    baseURL: process.env.VUE_APP_HERE_MAP_FLEET_API,
    url: '/2/calculateroute.json',
    method: 'get',
    params: params,
    headers: {
      'disable-token': true
    },
    cancelToken
  })
}

// 规划路线 routing v8
export function calculaterouteV8(params, cancelToken) {
  // 实际用法
  const routePlan = RoutePlan.fromFleetParams(params)

  return routePlan.getRoute(cancelToken)
}

// 规划路线 服务端算路
export function calculateServerRouting(params, cancelToken) {
  const routePlan = ServerRoutePlan.fromFleetParams(params)
  return routePlan.getRoute(cancelToken)
}

// 反向地理编码
export function revgeocode(params) {
  return service({
    baseURL: process.env.VUE_APP_HERE_MAP_REVGEOCODE_API,
    url: '/v1/revgeocode?lang=en-US&apiKey=' + process.env.VUE_APP_HERE_MAP_KEY,
    method: 'get',
    params: params,
    headers: {
      'disable-token': true
    }
  })
}

export function getTrackingRouteMatch(data, cancelToken) {
  return service({
    baseURL: process.env.VUE_APP_HERE_MAP_FLEET_API,
    url: '/2/calculateroute.json?mode=fastest;truck;traffic:disabled',
    method: 'post',
    params: {
      routeMatch: 1,
      legAttributes: 'shape,-links',
      // mode: 'fastest;truck;traffic:disabled',
      app_id: process.env.VUE_APP_HERE_MAP_APP_ID,
      app_code: process.env.VUE_APP_HERE_MAP_APP_CODE
    },
    data,
    headers: {
      'Content-Type': 'application/octet-stream',
      'disable-token': true
    },
    cancelToken
  })
}
